import type { MapDefinition } from '../shared/types.js';

export function resolveRuntimeRaceMap(
  roomMapId: string | undefined,
  activeMap: MapDefinition | null,
  catalogue: readonly MapDefinition[],
): MapDefinition | undefined {
  if (!roomMapId) return undefined;
  if (activeMap?.id === roomMapId) return activeMap;
  return catalogue.find((map) => map.id === roomMapId);
}
